require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-know-when-alt-text-should-be-left-blank.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-know-when-alt-text-should-be-left-blank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-know-when-alt-text-should-be-left-blank!./.cache/json/responsive-web-design-applied-accessibility-know-when-alt-text-should-be-left-blank.json
// module id = 2520
// module chunks = 231608221292675